module.exports = __webpack_public_path__ + "static/L5Y1-0fed75368c18aa585b31547c96aff6e6.jpg";